export default __webpack_public_path__ + "static/media/king2.4fdcd9a0.png";